<template>
  <div >
    <!-- <router-link to="/abc">asdsd</router-link> -->
    <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header " id='Dashboard'>
      <div class="slopedBack">

      </div>












      <header class="mdl-layout__header mdl-layout__header--scroll ">
        <div class="mdl-layout-icon"></div>
        <div class="mdl-layout__header-row ">

          <img id="logoNav" class="logo logoshift" src="../assets/logo.png" width="200px" />



          <!-- <div class="mdl-layout-spacer" ></div> -->




          <nav class="mdl-navigation">
            <a class="pumpsoft mdl-navigation__link" href="#pumpSelector" @click="changePart('main')" >Pump Selector</a>
            <a class="pumpsoft mdl-navigation__link" href="#dutyPoint" @click="changePart('friction')" >Duty Point Calculator</a>
            <a class="pumpsoft mdl-navigation__link" href="#sewage" @click="changePart('sewage')" >Sewage System Simulator</a>
            <a class="pumpsoft mdl-navigation__link" href="#instantOffer" @click="changePart('docs')">Instant Offer</a>
            <a class="pumpsoft mdl-navigation__link" href="#insight" @click="changePart('insight')" >
              Customer Insight</a>

            </nav>
          </div>
        </header>
        <div class="mdl-layout__drawer">
          <nav class="mdl-navigation">
            <a class="pumpsoft mdl-navigation__link" href="#pumpSelector" @click="changePart('main')" >Pump Selector</a>
            <a class="pumpsoft mdl-navigation__link" href="#dutyPoint" @click="changePart('friction')" >Duty Point Calculator</a>
            <a class="pumpsoft mdl-navigation__link" href="#sewage" @click="changePart('sewage')" >Sewage System Simulator</a>
            <a class="pumpsoft mdl-navigation__link" href="#instantOffer" @click="changePart('docs')">Instant Offer</a>
            <a class="pumpsoft mdl-navigation__link" href="#insight" @click="changePart('insight')" >
              Customer Insight</a>

            </nav>
          </div>
          <main class="mdl-layout__content" >
            <div class="page-content longScreen" >


    <div class="mdl-grid">
      <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage firstPage">


        <div class="mdl-grid">
          <!-- <div class="mdl-cell  mdl-cell--8-col-tablet mdl-cell--6-col-desktop  mdl-cell--4-col-phone  ">
          <div class="mdl-grid"> -->
          <div class="mdl-cell  mdl-cell--8-col-tablet mdl-cell--6-col-desktop   mdl-cell--4-col-phone  titleDiv">
            <h2>PumpSoft: Your Pumps, One Platform</h2>
            <h4>PumpSoft saves time, automates sales and increases availability for pump distributors and manufacturers</h4>

            <div class="mdl-cell mdl-cell--8-col-tablet mdl-cell--12-col-desktop   mdl-cell--4-col-phone formCont ">

              <form action="https://formspree.io/damien@pumpsoft.se" method="POST">
                <input class="textfield" type="text"  v-model="email" placeholder=" Enter your email..." name="email" >
                <input type="submit" class="mdl-button mdl-js-button  mdl-button--colored mdl-js-ripple-effect" value="Contact Sales">
              </form>

            </div>


          </div>


          <div class="mdl-cell  mdl-cell--8-col-tablet mdl-cell--6-col-desktop  mdl-cell--4-col-phone">
            <div class="mdl-grid">
              <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone">
                <img id="mock"  class="fullMock titleMock" src="../assets/searchShort.png"  />
              </div>
              <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--2-offset-desktop mdl-cell--4-col-tablet mdl-cell--2-col-phone ">
                <img id="mock"  class="fullMock titleMock" src="../assets/table.png"/>
              </div>
              <div class="mdl-cell mdl-cell--3-col-desktop  mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
                <img id="mock"  class="fullMock mockSide titleMock" src="../assets/chart.png"  />
              </div>
            </div>

          </div>
        </div>
      </div>

  <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage">
    <div class="slopedBack1">

    </div>
    <div class="mdl-grid ">
      <!-- <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
      <h1>Why us?</h1>
      </div> -->
        <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
            <div class="mdl-grid ">
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
      <h1 class="whiteText">Benefits</h1>
      <!-- </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone longDesc  "> -->
      <p class="whiteText">
      PUMPSOFT is a subscription based pump selection software for pump importers and exporters. We digitalize our clients portfolios and create a customized search engine with detailed technical specifications for each pump.

      </p>  <p class="whiteText">
      We do this by using machine learning to gather performance charts, drawings and technical specifications from multiple pump manufacturers on one platform.
      </p>  <p class="whiteText">

      We make the "your pumps, one platform" concept a reality by connecting the software to our clients' inventory system, enabling the user to find the right pump faster than ever before.
          </p>  <p class="whiteText">

          <!-- <p>
        PUMPSOFT is a subscription based pump selection software for both pump distributors and manufacturers that comes with an extensive catalog from the world’s leading pump manufacturers.
          </p>  <p>
        We use machine learning to gather performance charts, drawings and technical specifications from pump manufacturers. We continuously add more pumps to our database upon request.
          </p>  <p>
        Pumps will be added/removed according to pump distributors or manufacturers’ catalogues. -->
          </p>

      </div>
      </div>
        </div>
      <div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <div class="mdl-grid ">
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone  benefits ">

        <h3 class="">Save Time <i class="far fa-clock"></i> </h3>
        <p>
    Faster and more convenient pump selection. For distributors this means sales reps working in one pump selector instead of multiple.
        </p>
      </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--4-col-tablet mdl-cell--4-col-phone benefits">
        <h3 class="">Automate Sales <i class="fas fa-shopping-cart"></i></h3>
        <p>
    Automate the sales process by enabling customers to serve themselves with pump selection.
        </p>
      </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone benefits ">
        <h3 class="">Increased Availability <i class="fas fa-users"></i></h3>
        <p>
          Make it possible for your customers to serve themselves and rate pumps at anytime.
        </p>
      </div>
  </div>
  </div>

  </div>
  </div>


  <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage ">
    <div class="slopedBack2">

    </div>
<a name="pumpSelector"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   mdl-cell--middle"  >
      <h1 class="pumpSelectorTitle whiteText">Pump Selector</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone  partDescription ">
        <p class=" partDescription whiteText" >
        Pumpsoft is focused on <strong>speed</strong>, simplicity and flexibility in order to create a frictionless user experience. The program rates the pumps based on duty point, while also providing  more simplified selection based on capacity and max pressure or through the built-in search engine. PUMPSOFT can be further customized to account for high viscosity fluids, abrasive particles, ATEX requirement, special elastomers etc., which makes PUMPSOFT adaptable for all types of centrifugal pump and applications.

      </p>
      </div>
        <div class="mdl-cell mdl-cell--2-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock mockSide titleMock" src="../assets/searchShort.png"  />
</div>
<div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--3-col-tablet mdl-cell--2-col-phone   ">
<img id="" class="fullMock titleMock" src="../assets/table.png"/>
</div>
<div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock mockSide titleMock" src="../assets/chart.png"  />
</div>
</div>
  </div>


  <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage">
    <div class="slopedBack3">

    </div>
    <a name="dutyPoint"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1 class="pumpSelectorTitle whiteText">Duty Point Calculator</h1>
      </div>
      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription whiteText" >
          Pumpsoft comes with an <strong>intuitive</strong> Duty Point calculation tool that is completely integrated with the pump selector.
        </p>
      </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <img id="friction" class="fullMock" src="../assets/friction.png" width="100%" />
      </div>
    </div>
  </div>


  <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage">
    <div class="slopedBack4">

    </div>
    <a name="sewage"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1 class="pumpSelectorTitle whiteText">Simulator</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription whiteText" >
          The Simulator is an add-on module that calculates duty points and rate pumps for more complex piping systems with multiple pumps operating simultaneously. This <strong>saves time</strong> for sales reps and customers when rating pumps for larger projects.
        </p>
      </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <img id="friction" class="fullMock" src="../assets/sewage.png" width="100%" />
      </div>
    </div>
  </div>

  <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage">

    <div class="slopedBack6">

    </div>
    <a name="instantOffer"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1 class="pumpSelectorTitle whiteText">Instant Offer</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription whiteText" >
          Instantly generates a technical specification sheet with your brand on it, containing user inputs, actual duty point, performance charts, technical specifications and drawings.
        </p>
      </div>
      <!-- <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone mdl-shadow--24dp    "> -->
        <!-- <embed  src="/static/dataSheet.pdf" width="100%" height="500px" type='application/pdf' /> -->
        <div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock " src="../assets/pageOne.png"  />
</div>
<div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock " src="../assets/pageTwo.png"/>
</div>
<div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock " src="../assets/pageThree.png"/>
</div>
<div class="mdl-cell mdl-cell--3-col-desktop mdl-cell--2-col-tablet mdl-cell--1-col-phone   ">
<img id="" class="fullMock " src="../assets/pageFour.png"  />
</div>
      <!-- </div> -->
    </div>
    <a name="insight"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1 class="pumpSelectorTitle whiteText">Customer Insight</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription whiteText" >
        Enable sales reps to see what customers are searching for. This feature can be used by sales reps as an additional prospecting tool to generate <strong>hot leads.</strong>
        </p>
      </div>

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1 class="pumpSelectorTitle whiteText">Mobile</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription whiteText" >
          PUMPSOFT comes with a <strong>mobile version.</strong> Generate a data sheet on the phone with your brand, containing user inputs, duty point, performance charts and technical specifications.

        </p>
      </div>
      <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <img id="" class="mobile" src="../assets/iphoneSearch.png" width="50%" />
      </div>
      <!-- <div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
          <img  id="" class="" src="../assets/customerInsight.png" width="40%" />
      </div> -->
    </div>
  </div>


  <!-- <div class="mdl-cell mdl-cell--10-col-desktop mdl-cell--1-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone onePage">

    <a name="insight"></a>
    <div class="mdl-grid ">

      <div class="mdl-cell mdl-cell--5-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   "  >
        <h1>Customer Insight</h1>
      </div>
      <div class="mdl-cell mdl-cell--7-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone   ">
        <p class=" partDescription" >
        Enable sales reps to see what customers are searching for. This feature can be used by sales reps as an additional prospecting tool to generate <strong>hot leads.</strong>
        </p>
      </div>

    </div>
  </div> -->






<hr />
<div class="mdl-cell mdl-cell--12-col-desktop  mdl-cell--8-col-tablet mdl-cell--4-col-phone freeQuote">
  <div class="slopedBack7">

  </div>
  Request a <strong class="free">free </strong>demo and quote
</div>
<div class="mdl-cell mdl-cell--6-col-desktop mdl-cell--3-offset-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">


  <div class="mdl-grid">


  <!-- <div class="mdl-cell  mdl-cell--4-col-tablet mdl-cell--4-col-desktop  mdl-cell--2-col-phone  "> -->

  <div class="mdl-cell  mdl-cell--7-col-tablet mdl-cell--10-col-desktop  mdl-cell--1-offset-desktop mdl-cell--4-col-phone  ">
    <!-- <label class="" for="company" >Company </label> -->
    <form action="https://formspree.io/damien@pumpsoft.se" method="POST">
      <input class="textfield" type="text"  v-model="email" placeholder="  Enter your email..." name="email" >
      <input type="submit" class="mdl-button mdl-js-button  mdl-button--colored mdl-js-ripple-effect" value="Contact Sales">
    </form>
      </div>


</div>
<!-- </div> -->

</div>
</div>


<div class="mdl-cell mdl-cell--12-col-desktop mdl-cell--8-col-tablet mdl-cell--4-col-phone">
  <div class="mdl-grid">


    <div class="mdl-cell  mdl-cell--4-col-tablet mdl-cell--2-col-desktop  mdl-cell--4-col-phone">
      <img id="logoNav" class="logo logoshift" src="../assets/pumpsoftwhite.png" width="200px" />

    </div>
    <div class="mdl-layout-spacer" ></div>
    <div class="mdl-cell  mdl-cell--4-col-tablet mdl-cell--6-col-desktop  mdl-cell--4-col-phone">
      <!-- <h4 class="footerContact">Contact</h4> -->
      <ul >
        <li><i class="material-icons">&#xE0E1;</i><a href="#">    robert@pumpsoft.se</a></li>
        <li class="footerDetails" > <i class="material-icons">&#xE88A;</i> Lindstedtsvägen 24, floor 4 100 44 Stockholm</li>
        <li class="footerDetails"><i class="material-icons">&#xE0CF;</i> +46 764 664 018</li>
      </ul>
    </div>
  </div>
</div>
</div>
</main>
</div>
</div>
</template>

<script>
// import componentHandler from 'exports-loader?componentHandler!material-design-lite/material'
import axios from 'axios'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      email: '',
      company: '',
      part: 'main'
    }
  },
  updated () {
    // this.$nextTick(() => {
    //   componentHandler.upgradeDom()
    // })
  },
  methods: {
    contact: function () {
      axios({
        method: 'post',
        url: 'https://formspree.io/damien@pumpsoft.se',
        data: {email: this.email},
        headers: {'X-Requested-With': 'XMLHttpRequest'}
      })
    },
    changePart: function (part) {
      this.part = part
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.fullMock {
  border-radius: 10px;
  padding: 4px;
  background-color: white;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
     /* transform: rotate(-10deg); */
     width: 100%;
       z-index: 9999 !important;
}
.mockSide {
  /* padding-bottom: 25px; */
    /* z-index: 999; */
}
#mock {
  border-radius: 10px;
  padding: 4px;
  background-color: white;
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);

      transform: scale(1.8);
        /* z-index: 999; */
}
.titleMock {
  margin-top: 10vh;
  /* transform: rotateX(60deg) rotateY(0deg) rotateZ(-75deg); */
}
.titleMock>h2 {
  color: #364883;
}
.titleDiv>h2 {
  /* color: #364883; */
  color: white;
  /* margin-top: -80px; */
}
.titleDiv {
    /* top: 30vh; */
}

.onePage {
  /* margin-top: 20vh; */
    /* margin-bottom: 20vh; */
  min-height: 100vh;
  max-height: 100%;
}
.firstPage {
  margin-top: 15vh;
  /* margin-bottom:-10vh; */
}
h1, h2 {

  font-weight: 500;
  color: #364883;
  /* text-shadow: 1px 1px 10px #fff; */
}
h3 {
text-align:center;
/*padding-left: 15px;*/
  /* color: #364883; */
  color: #007adf;
font-weight: 500;
text-shadow: 1px 1px 10px #fff;
}
h4 {
text-align:center;
/*padding-left: 15px;*/
  /* color: #477db4; */
  color: white;
font-weight: 500;
}
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #268ef6;
}

.longScreen {
  height: 100%;
background: transparent;

}
.mdl-navigation {
  margin-left: 20vw !important;
}
nav .mdl-navigation__link {
  text-transform: uppercase;
  /* color: #364883; */
  color: #007adf;
  font-weight: 600;
    font-size: 11px;
      text-shadow: 1px 1px 10px #fff;
      -moz-transition: all 275ms cubic-bezier(0.53, -0.67, 0.73, 0.74);
-o-transition: all 275ms cubic-bezier(0.53, -0.67, 0.73, 0.74);
-webkit-transition: all 275ms cubic-bezier(0.53, -0.67, 0.73, 0.74);
transition: all 275ms cubic-bezier(0.53, -0.67, 0.73, 0.74);
}
.mdl-navigation__link:hover {
  cursor: pointer;
  margin-top: -5px !important;

}
p {
  /* color: white ; */
    color: #364883;
  /*color: lightgrey;*/
  font-size: 18px;
  text-align:justify;
  /*padding-left: 30px;*/
    /*padding-right: 10px;*/
    font-weight: 500;
    /*padding-top: 20px;*/
    /* text-shadow: 1px 4px 21px #fff; */
}
.footerContact {
  margin-top: -30px;
  margin-bottom: -10px;
  color: white
}
.bigIcon {
  font-size: 40px;
  /* text-shadow: 1px 4px 10px #000; */
}
.benefits {
background-color: rgba(255, 255, 255, 0.98);

/* border: solid 0.5px grey !important; */
border-radius: 10px;
border: 1px white solid;
color: #373737;
text-align: center;
box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}

.benefits>p {
  text-align: center;
  padding: 0 20px;
  padding-top: 0px;
  color: #949494;
}
.benefits>svg {
  color: #364883
}
.mobile {
  width: 200px;
  background-color: white;
  border-radius: 5px;
  border: 5px solid white;
     box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
}
.point {
  margin-top: -2px;
  margin-bottom: 0px;
font-size: 22px;
  cursor: pointer;
}
.demos {
  background-color: white;
  border-radius: 5px 5px 0 0;
  border-top: solid 1px #c2c2c2;
}
.mdl-layout__header-row {
  /* margin-top: -10px; */
  /* background-color: #fff; */
  /* background-color: rgba(255, 255, 255,0.75) */
  /*background-color: #f2f2f2;*/

}
hr {
  color: white;
}
.logo {
  z-index: 10;
/* padding: 3px; */
/* border-radius: 20px; */
/* -webkit-box-shadow: 1px 1px 1px 0px rgba(0,0,0,0.25) !important;
-moz-box-shadow: 1px 1px 1px 0px rgba(0,0,0,0.25) !important;
box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.25) !important; */
/* background: -webkit-linear-gradient(70deg,#477db4, #364883);
background: -o-linear-gradient(70deg, #477db4, #364883);
background: -moz-linear-gradient(70deg, #477db4, #364883);
background: linear-gradient(70deg, #477db4, #364883); */

}
.mdl-layout-icon {
  color:#00ecbc !important;
}
.slopedBack {
  position:absolute;
  /* top:50vh; */
  /* left:45vw; */
  height: 75vh;
  width:100vw;
  z-index:1;
  transform: skewY(0deg);
  /* border-radius: 90%; */
background-color: #007adf;
    /* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
    /* background-image: linear-gradient(to top, rgba(118,169,219, 0.68) 0%, #0064c1 100%); */

        /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */
    /* -moz-box-shadow:    inset 0 0 20px #000000;
  -webkit-box-shadow: inset 0 0 20px #000000;
  box-shadow:         inset 0 0 20px #000000; */
}
.slopedBack1 {
  position:absolute;
  /* top:90vh; */
  height: 85vh;
  left: -50vw;
  width:160vw;
  z-index:-3;
    /* transform: skewY(8deg); */
  /* transform: skewY(-8deg); */
    /* border-radius: 37%; */
    /* border-top-right-radius: 77%;  */
    /* border-top-left-radius: 87%;
        border-bottom-right-radius: 90%;
         border-bottom-left-radius: 80%; */
        /* background-image: linear-gradient(to top, #0fd850 0%, #f9f047 100%); */
  /* background-color: rgba(219, 219, 219, 0.51); */
  /* background-image: linear-gradient(to right, #243949 0%, #517fa4 100%); */
  /* background-color: #007adf; */
  background-color: #007adf;
  /* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
/* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */

}



.slopedBack2 {
  position:absolute;
  /* top:2vh; */
  height: 100vh;
    left:-40vw;
  width:150vw;
  /*left:50%;*/
  z-index:-1;
  /* transform: skewY(28deg);  */
  /* border-radius: 37%;
  border-top-right-radius: 77%;
  border-top-left-radius: 87%;
      border-bottom-right-radius: 90%;
       border-bottom-left-radius: 80%; */
  /* transform: skewY(-8deg); */
/* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */
  /* background-image: linear-gradient(-225deg, rgba(34, 225, 255, 0.31) 0%, rgba(29, 143, 224, 0.52) 48%, rgba(98, 94, 177, 0.2) 100%); */

   /*box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */
  /* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
    background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%);
    /* background-image: linear-gradient(to top, #00c6fb 0%, #005bea 100%); */
}
.slopedBack3 {
  position:absolute;
  /* top:340vh; */
  height: 80vh;
    left:-10vw;
  width:140vw;
  z-index:-1;
  /* transform: skewY(-3deg); */
    /* border-radius: 57%;
    border-top-right-radius: 77%;
    border-top-left-radius: 47%;
        border-bottom-right-radius: 97%; */
  /* background-image: linear-gradient(-225deg, rgba(34, 225, 255, 0.51) 0%, rgba(29, 143, 224, 0.52) 48%, rgba(98, 94, 177, 0.5) 100%); */
      /* background-image: linear-gradient(to top, #65bd60 0%, #5ac1a8 25%, #3ec6ed 50%, #b7ddb7 75%, #fef381 100%); */
          /* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
/* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
/* border: 1px solid #00ecbc; */
  background-color: #3cba92;
    /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */
}
.slopedBack4 {
  position:absolute;
  /* top:420vh; */
  height: 80vh;
    left:-10vw;
  width:160vw;
  z-index:-1;
  /* transform: skewY(10deg); */
    /* border-radius: 57%;
    border-top-right-radius: 47%;
    border-top-left-radius: 57%;
        border-bottom-right-radius: 27%; */
  /* background-image: linear-gradient(-225deg, rgba(34, 225, 255, 0.51) 0%, rgba(29, 143, 224, 0.52) 48%, rgba(98, 94, 177, 0.5) 100%); */
  /* background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%); */
  background-color: #007adf;
    /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */
}


/* .slopedBack5 {
  position:absolute;
  top:550vh;
  height: 50vh;
        left:-60vw;
  width:100vw;
  z-index:-1;
  transform: skewY(-38deg);
    border-radius: 57%;
    border-top-right-radius: -77%;
    border-top-left-radius: 87%;
        border-bottom-right-radius: 97%;
background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%);
  box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);

} */

.slopedBack6 {
  position:absolute;
  /* bottom: 40vh; */
  height: 90%;
    left:-40vw;
  width:160vw;
  z-index:-1;
  /* transform: skewY(2deg); */
    /* border-radius: 57%;
    border-top-right-radius: 17%;
    border-top-left-radius: 57%;
        border-bottom-right-radius: 97%; */
  /* background-image: linear-gradient(-225deg, rgba(34, 225, 255, 0.51) 0%, rgba(29, 143, 224, 0.52) 48%, rgba(98, 94, 177, 0.5) 100%); */
  background-color: #3cba92;
/* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
  /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */

}


.slopedBack7 {
  position:absolute;
  bottom:0;
  height: 300px;
    left:0;
  width:100vw;
  z-index:-1;
  /* transform: skewY(-8deg); */
    /* border-radius: 57%; */
    /* border-top-right-radius: 77%;
    border-top-left-radius: -87%; */
        /* border-bottom-right-radius: 97%; */
  /* background-image: linear-gradient(-225deg, rgba(34, 225, 255, 0.51) 0%, rgba(29, 143, 224, 0.52) 48%, rgba(98, 94, 177, 0.5) 100%); */
  /* background-image: linear-gradient(to top, #00c6fb 0%, #005bea 100%); */
  /* background-image: linear-gradient(to top, #007adf 0%, #00ecbc 100%); */
background-color: #007adf;
  /* background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%); */
  /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2); */

}



.longDesc {
  padding-top: 10vh;

}
.longDesc>p {
    /* color: white ; */
}
.mdl-card {
  z-index: 999;
}
.formCont {
  /* background-color: #007adf;
  border: solid 10.5px #007adf;
    border-radius: 57%;
    border-top-right-radius: 97%;
    border-top-left-radius: 87%;
        border-bottom-right-radius: 97%; */
}
.textfield {
  background-color: white;
  z-index: 1;
  /*width: 100%;*/
  /* min-width: 200px; */
  /*border-top: solid 1px grey;
  border-bottom: solid 1px grey;*/
  border: none;
    border: solid 1px #007adf;

  /* border-bottom: solid 2.5px #007adf; */
  /* border-radius: 3px; */
  /* margin:1px !important; */
  /* margin-right:-25px !important; */
  color: rgb(129, 129, 129);
  padding:6px !important;

  border-radius: 20px;
  line-height: 24px;
  font-size: 16px;
  /* margin-top: -22px; */
  width:50%;
       /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2); */
box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 1.5px 0.5px -1px rgba(0, 0, 0, 0.2), 0 0.5px 2.5px 0 rgba(0, 0, 0, 0.12);

}
.textfield:active:focus {
   outline: none;

}
.textfield:focus {
     color: rgb(111, 111, 111) !important;
      outline: none;
}
.selectedPart {
  border-radius: 2px;
  /*border-spacing: 4px;*/
  background-color: #268ef6;
  color: white;
}
.point:hover {
  background-color: #77bbff  !important;
  color: white;
  border-radius: 3px;
  /*-webkit-box-shadow: 1px 1px 1px 0px rgba(0,0,0,0.25) !important;
-moz-box-shadow: 1px 1px 1px 0px rgba(0,0,0,0.25) !important;
box-shadow: 1px 1px 1px 0px rgba(0,0,0,0.25) !important;*/
}
.mdl-button {
  /* margin-left: -30px; */
    color: #fff;
  border-radius: 20px;
  border: none;
  /* background: -webkit-linear-gradient(70deg,#477db4, #8cc7ed);
 background: -o-linear-gradient(70deg, #477db4, #8cc7ed);
 background: -moz-linear-gradient(70deg, #477db4, #8cc7ed);
 background: linear-gradient(70deg, #477db4, #8cc7ed); */
 /* background-image: linear-gradient(to right, #f78ca0 0%, #f9748f 19%, #fd868c 60%, #fe9a8b 100%); */
background-image: linear-gradient(to top, #0ba360 0%, #3cba92 100%);
box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
       /* box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2); */
margin-top: -5px;
}
.mdl-button:hover {
  top: -1px !important;
  /* border: solid 0.5px grey; */
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.2);
}
.partDescription {
  margin-top: 20px;
  /*background-color: rgba(255, 255, 255, 0.88);*/
  border-radius: 2px;
  background-color: transparent;
  /* font-size: 14px; */
    font-size: 18px;
  /*border: solid 0.5px grey !important;*/
  padding-top: 20px;
}
.screenshots {
  background-color: white;
}
.mdl-mini-footer {
  border-top: solid 2px #e2e2e2;
  background-color: #f2f2f2;
  color: white
}
.footerDetails {
  color: white;
  font-size: 16px;
}
label {
  font-size: 16px;
  color: black;
  /*min-width: 200px;*/
  text-align: left;
  border: none;
  padding-bottom: -10px !important;
  padding-left: -10px !important;
  /*border-bottom: solid 1px grey;*/
}


.mdl-button--colored {
  background-color: #218b35;

}


@media only screen and (max-width:1024px) {
  .mdl-button--colored {
    /* left: 35%; */
  }
  .mdl-navigation {
    visibility:hidden;
  }
  .firstPage {
    margin-top: 2vh ;
    margin-bottom:-10vh ;
  }
  .thirdPage {
    margin-top: 40vh ;
      margin-bottom: 5vh ;
  }
  .pumpSelectorTitle {
    margin-bottom: 2vh !important;
  }
  #mock {
    transform: scale(1.2);
  }
  .titleMock {
    margin-top: 0vh ;
    /* transform: rotateX(60deg) rotateY(0deg) rotateZ(-75deg); */
  }
  .benefits>h3 {
    /* font-size: 36px !important; */
    margin-bottom: 10px;
  }
  .benefits>p {
    /* font-size: 28px !important; */
  }

  .onePage {
    /* height: 100% !important; */
  }
  /* p {
    font-size: 28px !important;
    text-align:left;
  } */
}

@media only screen and (max-device-width:736px) {
  .firstPage {
    /* margin-bottom: 10vh !important; */
    margin-top: 2vh;
    /* transform: rotateX(60deg) rotateY(0deg) rotateZ(-75deg); */
  }
  .thirdPage {
    /* margin-bottom: 10vh !important; */
    /* margin-top: 10vh !important; */
    /* transform: rotateX(60deg) rotateY(0deg) rotateZ(-75deg); */
  }
  .onePage {
    /* height: 100% !important; */
  }
  .pumpSelectorTitle {
    /* margin-bottom: 2vh !important; */
  }
  .benefits>h3 {
    /* font-size: 36px !important; */

  }
  .slopedBack1 {
    height: 140vh;
  }

  .slopedBack2 {
    height: 140vh;
  }

  .benefits>p {
    /* font-size: 8px !important; */
  }
  #mock {
    /* transform: scale(1); */
  }
  p {
    /* font-size: 8px !important; */
  }

}
main {
  /*background-color: #f2f2f2;*/
  background-color: transparent;
  overflow-y:  hidden;
}
footer {
color: white
}
ul {
  display: inline;
}

ul li{
  display: inline-block;
}
li>a {
  color:white !important;
}
li>i {
    color:white !important;
}
.free {
      color: white
}
.freeQuote {
  font-size: 28px;
  text-align: center;

  font-weight: 400;
  color: white
}
.whiteText {
  color: white
}
.mdl-layout__header {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue